import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
} from '../theming/Titles.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { align1ejncrrer3meh as align } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { ExternalLink3fl954ixvn5zt as ExternalLink } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ExternalLink.commonHtml.mjs';
import { get_bold1rri6ahk98puv as get_bold } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../theming/colorManagement.mjs';
import { ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { specCenteredText1zemopd0g3rsf as specCenteredText } from '../theming/buttons.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { dialogView37nkwa7nowbx3 as dialogView } from './GenericDialog.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function HelpDialog$render$lambda($this$dialogView) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$dialogView.pc());
  var tmp0_elvis_lhs = $this$dialogView.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$dialogView : tmp0_elvis_lhs;
  $this$dialogView.gbb(p, view);
  view.zbm(true);
  view.bb9(get_rem(2));
  title(view, 'Help');
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_AppDimensions().ig2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint)));
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.bb9(get_rem_0(0.3));
  view_0.lbb(align(view_0, Align_Start_getInstance(), Align_Center_getInstance()), body(view_0, 'For Stoze troubleshooting and help please contact:'));
  var tmp = align(view_0, Align_Start_getInstance(), Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.externalLink' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (ExternalLink())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.gba(get_dp(1));
  view_1.lbb(view_1.kbb(get_bold(view_1), colored(view_1, AppColors_getInstance().lfz_1.zg9_1)), body(view_1, 'help@stoze.io'));
  // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.to' call
  var value = 'mailto:help@stoze.io';
  // Inline function 'com.lightningkite.kiteui.views.href' call
  view_1.vb5_1.bb4_1.kb7_1.href = value;
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp, view_1);
  view.hbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_2 = view.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.gbb(p_2, view_2);
  view_2.zbm(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp_0 = view_2.jbb(ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  specCenteredText(view_3, 'OK');
  onClick(view_3, VOID, VOID, HelpDialog$render$lambda$slambda_0());
  view_2.hbb(p_3, view_3);
  view_2.lbb(tmp_0, view_3);
  view.hbb(p_2, view_2);
  $this$dialogView.hbb(p, view);
  return Unit_instance;
}
var HelpDialog$render$lambda$slambdaClass;
function HelpDialog$render$lambda$slambda() {
  if (HelpDialog$render$lambda$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    HelpDialog$render$lambda$slambdaClass = $;
  }
  return HelpDialog$render$lambda$slambdaClass;
}
function HelpDialog$render$lambda$slambda_0() {
  var i = new (HelpDialog$render$lambda$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var HelpDialogClass;
function HelpDialog() {
  if (HelpDialogClass === VOID) {
    class $ {
      wd6(_this__u8e3s4) {
        return dialogView(_this__u8e3s4, HelpDialog$render$lambda);
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'HelpDialog', HelpDialog, VOID, [Page()]);
    HelpDialogClass = $;
  }
  return HelpDialogClass;
}
//region block: exports
export {
  HelpDialog as HelpDialog1lwp0zwjcf7tt,
};
//endregion

//# sourceMappingURL=HelpDialog.mjs.map
